import { connect } from 'react-redux';
import { getURL } from '~/server/formatters';
import TabNavigation from './components/TabNavigation';

// default export = container
export default connect(state => {
  const { hasApprovalFeature } = state.organizations.selected || {};
  return {
    profileNavTabs: state.profileNav.profileNavTabs,
    profileId: state.profileSidebar.selectedProfile.id,
    showNestedAnalyticsTab: state.profileNav.selectedTabId === 'sentPosts',
    showNestedSettingsTab: state.profileNav.selectedTabId === 'settings',
    showReconnectButton:
      state.profileSidebar.selectedProfile.isDisconnected &&
      state.organizations.selected?.canReconnectChannels,
    draftsNeedApprovalCount: state.profileNav.draftsNeedApprovalCount,
    draftsCount: state.profileNav.draftsCount,
    reconnectURL: getURL.getAccountChannelsURL(),
    showApprovalPaywallTag: !hasApprovalFeature,
    shouldShowNavUpgradeCta:
      state.organizations.selected?.shouldShowNavUpgradeCta,
  };
})(TabNavigation);

// export reducer, actions and action types
export { default as reducer, actions, actionTypes } from './reducer';
export { default as middleware } from './middleware';
